"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const pino_1 = __importDefault(require("pino"));
const ModuleIdHelper_1 = require("../modules/ModuleIdHelper");
class LogHelper {
    /**
     * Gets a log name for a given module.
     * @param module
     */
    static getLogName(module) {
        const moduleId = (0, ModuleIdHelper_1.getModuleId)(module);
        const parts = moduleId === null || moduleId === void 0 ? void 0 : moduleId.replaceAll(/\.(tsx?|jsx?)/gi, '').split(/[/_]/);
        return parts === null || parts === void 0 ? void 0 : parts.at(-1);
    }
    /**
     * Validates a log level to make sure it's allowed.
     * @param logName
     * @param logLevel
     * @return the level or null if it's invalid.
     */
    static validateLogLevel(logName, logLevel) {
        var _a;
        if (logName && logLevel) {
            const level = logLevel.toLowerCase();
            const { values } = pino_1.default.levels;
            if (values[level] === undefined) {
                (_a = global.appLog) === null || _a === void 0 ? void 0 : _a.warn('Unable to set %s log level to %s as it is an invalid value.  Valid values are: %s', logName, logLevel, Object.keys(values));
            }
            else {
                return level;
            }
        }
        return null;
    }
}
exports.default = LogHelper;
//# sourceMappingURL=LogHelper.js.map